import moment from "moment";

export const renderDate = (date?: Date | null | string) => {
  if (date) {
    return moment(date).format("MM/DD/YYYY");
  }
  return "N/A";
};
